import { Flex } from '@elementary/common-ui/components';
import { WarehouseType } from '@elementary/common-ui/types';
import { Typography } from '@mui/material';
import WarehouseTypeIcon from './WarehouseTypeIcon';

type Props = {
  name: string;
  warehouseType: WarehouseType;
};

const WarehouseLabel = ({ name, warehouseType }: Props) => (
  <Flex sx={{ gap: 1, alignItems: 'center', minWidth: 0 }}>
    <WarehouseTypeIcon warehouseType={warehouseType} />
    <Typography noWrap>{name}</Typography>
  </Flex>
);

export default WarehouseLabel;
